import { useQuery } from "@tanstack/react-query";
import { fetchUserData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api";
import { IEmployeeData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/Forms/OrganizationStructureForm.models";

const useFetchUserData = (companyId: string, employeeId: string) =>
  useQuery<IEmployeeData, Error>({
    queryKey: ["fetch-user-form-data"],
    queryFn: async ({ signal }) => {
      const data = await fetchUserData(companyId, employeeId, { signal });
      return data;
    },
    enabled: !!companyId && !!employeeId,
  });

export default useFetchUserData;
